<template>
    <div class="detail">
        <div class="greyCeng" v-if="isShowCalendar" @click="showCalendar()"></div>
        <!--其他日历-->
        <calendarOther  v-if="isShowCalendar && !isHotel" :goods_id="goods_id" :date_range="date_range" :ajax_date_range="ajax_date_range" :todayStopSellTime="goods_info.hour_td" @changeShowCalendarStatus="showCalendar()" @userChooseDate="changeDate($event)" @userChoosePrice="changePrices($event)"></calendarOther>
         <!--<calendar v-if="isShowCalendar" :goods_id="goods_id" :date_range="date_range" :ajax_date_range="ajax_date_range" :todayStopSellTime="goods_info.hour_td" @changeShowCalendarStatus="showCalendar()" @userChooseDate="changeDate($event)" @userChoosePrice="changePrices($event)"></calendar>-->
        <!--酒店日历-->
        <calendar v-if="isShowCalendar && isHotel" :goods_id="goods_id" :buyNum="buyNum" :market_price="Number(market_price)" :value="value" :begin="begin" :end="end" @select="selectdate" @selectinfo="selectinfo"></calendar>
        <mt-swipe :auto="4000" class="swiper">
            <!-- <mt-swipe-item class="swiper-item"><img src="../../assets/images/xuebi_24.png" alt=""></mt-swipe-item>
            <mt-swipe-item class="swiper-item"><img src="../../assets/images/xuebi_24.png" alt=""></mt-swipe-item>
            <mt-swipe-item class="swiper-item"><img src="../../assets/images/xuebi_24.png" alt=""></mt-swipe-item> -->
            <mt-swipe-item class="swiper-item" v-for="(picUrl,index) in goods_info.images_list" :key="index"><img :src="weburl + picUrl"></mt-swipe-item>
        </mt-swipe>
        <div class="ticket_detail">
            <h1>{{goods_info.goods_name}}</h1>
            <ul>
                <li v-for="(k,i) in this.getKeyWords(goods_info.keywords)" :key="i">{{k}}</li>
            </ul>
            <p>优惠价格： <span class="discounts_price">{{this.unitPrices}}</span><s>￥{{this.market_price}}</s></p>
            <p>兑换方式：短信、二维码</p>
            <p class="buy_num">购买数量：{{buyNum}}<span class="del" @click="delNum()">-</span> <input type="text" v-model="buyNum"> <span class="add" @click="addNum()">+</span></p>
            <!-- <p>出游日期：<span class="detail_calendar" @click="openPicker()">{{date}}</span></p> -->
            <p>出游日期：<span class="detail_calendar" @click="showCalendar()">{{ select_date_range | transitionNullDateFunc }}</span></p>
            <Date-time ref="dateTime" type="date" @confirm="select"></Date-time>
            <div class="detail_btns">
                <div>
                    <b>总计：</b>
                    <span class="all_price">{{this.totalPrices}}</span>
                </div>
                <span class="buyCar" @click="addBuyCar()">加入购物车</span>
                <span class="bookBtn" @click="bookBtnFunc(goods_info.cat_id_2)">立即预定</span>

            </div>
        </div>
        <div class="detail_info" v-html="replaceHtml(goods_info.goods_content)"></div>
    </div>
</template>

<script>
    import {Toast} from 'mint-ui';
    import DateTime from 'vue-date-time-m';
    import calendar from './calendar.vue';
    import calendarOther from './calendar2';

    export default {
        name: "detail",
        props:["goods_info"],
        inject:['replaceHtml'],
        data:function () {
            return {
                goods_id:Number(this.$route.query.goods_id),
                isShowCalendar:false,              //是否显示日历，默认是不显示日历
                buyNum:1,
                select_date_range:"",
                unitPrices:"",
                market_price:"",
                totalPrices:"",
                infoHtml:this.htmlDecode(this.goods_info.goods_content),
                date_range:{},                             //可以售卖的时间期限
                ajax_date_range:"",                        //ajax请求回来的售卖时间的数据（未变形）
                // date:this.getNowFormatDate(),
                date:"",
                begin:"",
                end:"",
                date_begin:"",
                date_end:"",
                value:[], //默认日期
                hour_td:'14:00:00',
                todayStopSellTimestamps:"",      //该商品当天购买的截至时间戳
                isHotel: false,
                // goodsPriceAndStoreCountTwo:this.setUpInitArr()
            }
        },
        components: {
            DateTime,
            calendar,
            calendarOther
        },
        computed:{
            weburl: function () {
                return this.$store.state.weburl;
            },
            hurl: function () {
                return this.$store.state.hurl;
            }
        },
        created:function () {
            let now = new Date();
            this._year = now.getFullYear();
            this._month = now.getMonth();
            this._day = now.getDate();
            this.getCanSellDate();
            this.getTotalPricesFunc();
        },
        filters: {
            transitionNullDateFunc: function (val) {
                if(!val){
                    return "请选择日期";
                }else{
                    return val;
                }
            }
        },
        mounted:function () {
        },
        methods:{
            getTodayStopSellTimeFuncs: function (todayStopSellDates,hour_td) {
                // let todayStopSellDates = this.getNowFormatDate();
                // let todayStopSellDateTimestamps = new Date((todayStopSellDates + " " + hour_td).replace(/-/g,'/')).getTime()/1000;
                return new Date((todayStopSellDates + " " + hour_td).replace(/-/g, '/')).getTime() / 1000;
            },
            setUpInitArr: function () {
                let arr = [];
                let obj = {
                    date:"",
                    day:0,
                    is_edited:false,
                    is_holiday:false,
                    is_sell:0,
                    price:"",
                    price_from:0,
                    store_count:0,
                    store_count_from:0,
                    store_count_remainder:0
                };
                for(var i = 0;i < 42;i++){
                    arr.push(obj);
                }
                return arr;
            },
            // =========
            // 获取价格的方法，此方法是为了弥补缺陷，虽然比较多余，先凑合用吧
            getTotalPricesFunc: function () {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + this.hurl + "/Goods/reservesInfo",
                    dataType: "json",
                    data: {
                        id: this.$route.query.goods_id        //商品id：goods_id
                    }
                })
                .then(res => {
                    if (res.data.status === 1) {
                        console.log(res.data.result)
                        // this.$store.commit("set_goods_details", res.data.result);
                        this.totalPrices = res.data.result.shop_price;
                        this.unitPrices = res.data.result.shop_price;
                        this.market_price = res.data.result.market_price;
                        // console.log(res.data.result.hour_td);
                        switch (res.data.result.cat_id_2) {
                            case 854: case 848: case 860:
                                this.isHotel =false;
                                break;
                            case 859:
                                this.isHotel =true;
                                break;
                        }
                        this.hour_td = res.data.result.hour_td;
                        this.todayStopSellTimestamps = this.getTodayStopSellTimeFuncs(this.getNowFormatDate(),this.hour_td);
                    }
                })
                .catch(err => {
                    console.log(err);
                })
            },
            changeDate: function (date) {
                this.date = date;
                this.date_begin = date;
                this.date_end = date;
                this.select_date_range = date;
            },
            selectdate: function (begin,end){
                this.date = begin;
                this.date_begin = begin;
                this.date_end = end;
            },
            selectinfo: function (select_date_range,market_price,unitPrices){
                this.select_date_range = select_date_range;
                var str = select_date_range.replace(/\//g, ',').split("-");
                for (var i=0;i<str.length ;i++ ){
                    str[i] = str[i].split(",");
                }
                this.value = str;
                this.market_price = market_price;
                this.unitPrices = unitPrices;
                this.totalPrices = Number(unitPrices)*this.buyNum;
            },
            changePrices: function (prices) {
                this.unitPrices = prices;
            },
            // 获取商品开卖的时间，年与月
            getCanSellDate: function () {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + this.hurl + "/Goods/get_goods_is_sell",
                    dataType: "json",
                    data: {
                        goods_id: this.goods_id        //商品id：goods_id
                    }
                })
                .then(res => {
                    // var year_start = 2020
                    // var month_start = 1
                    // var day_start = 13
                    // var year_stop = 2021
                    // var month_stop =12
                    // var day_stop = 31
                    var year_start = res.data.result.year_start;
                    var year_stop = res.data.result.year_stop;
                    var month_start = res.data.result.month_start;
                    var month_stop = res.data.result.mouth_stop;
                    var day_start = res.data.result.day_start;
                    var day_stop = res.data.result.day_stop;
                    var sellLastDay = new Date(year_stop, month_stop, 0).getDate();
                    this.ajax_date_range = res.data.result;
                    this.create_date_month(year_start, month_start, year_stop, month_stop);

                    if (year_start <= this._year) {
                        year_start = this._year;
                        if (month_start <= this._month+1 && year_start == this._year) {
                            month_start = this._month+1;
                        }
                    }
                    if (year_start <= this._year && month_start <= this._month+1) {
                        day_start = this._day;
                    }


                    this.begin = [year_start,month_start,day_start]; //可选开始日期
                    this.end = [year_stop,month_stop,day_stop]; //可选结束日期

                    // this.events = {
                    //     '2019-7-7':'￥408.00',
                    //     '2019-7-20':'￥408.00',
                    //     '2019-7-21':'￥8888.00',
                    //     '2019-7-22':'￥6666.00',
                    // };



                })
                .catch(err => {
                    console.log(err);
                });
            },
            getGoodsPriceAndStoreCountTwo: function (y,m) {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + this.hurl + "/goods/ajax_get_order_goods_price_store",
                    dataType: "json",
                    data: {
                        goods_id: this.goods_id,
                        year:y,
                        month:m
                    }
                })
                .then(res => {
                    if(res.data.status == 1){
                        // this.goodsPriceAndStoreCountTwo = [];
                        var arr = res.data.data.datas;
                        for(var i = 0;i < 42;i++){
                            let obj = {
                                date:"",
                                day:0,
                                is_edited:false,
                                is_holiday:false,
                                is_sell:0,
                                price:"",
                                price_from:0,
                                store_count:0,
                                store_count_from:0,
                                store_count_remainder:0
                            }
                            if(i < this.calendar[0].weekNum){
                                this.goodsPriceAndStoreCountTwo.push(obj);
                            }else{
                                if(i-this.calendar[0].weekNum < this.calendar.length){
                                    this.goodsPriceAndStoreCountTwo.push(arr[i-this.calendar[0].weekNum]);
                                }else{
                                    this.goodsPriceAndStoreCountTwo.push(obj);
                                }
                            }
                        }
                        // console.log(this.goodsPriceAndStoreCountTwo);
                    }
                })
                .catch(err => {
                    console.log(err);
                })
            },
            init_month_range: function () {
                var now_year = new Date().getFullYear();
                var now_month = new Date().getMonth() + 1;
                var months = this.date_range[now_year];
                this.data_month_range = months;
            },
            create_date_month: function (year_start, month_start, year_stop, month_stop) {
                for (var i = year_start; i <= year_stop; i++) {
                    var month_range = [];
                    if (year_start == year_stop) {
                        for (var j = month_start; j <= month_stop; j++) {
                            month_range.push(j);
                        }
                        this.date_range[i] = month_range;
                    } else {
                        if (i == year_start) {
                            for (var j = month_start; j <= 12; j++) {
                                month_range.push(j);
                            }
                            this.date_range[i] = month_range;
                        } else if (i == year_stop) {
                            for (var j = 1; j <= month_stop; j++) {
                                month_range.push(j);
                            }
                            this.date_range[i] = month_range;
                        } else {
                            for (var j = 1; j <= 12; j++) {
                                month_range.push(j);
                            }
                            this.date_range[i] = month_range;
                        }
                    }
                }
                // this.date_range = {
                //     2019:[5,6,7,8,9,10,11,12],
                //     2020:[2,3,4,5,6]
                // };
            },
            // 显示日历
            showCalendar: function () {
                if(this.isShowCalendar){
                    this.isShowCalendar = false;
                }else{
                    this.isShowCalendar = true;
                }
            },
            // 点击“加入购物车”
            addBuyCar:function () {
                if(!this.date){
                    Toast("请选择购买日期");
                    return false;
                }
                // let tody = this.getNowFormatDate();
                let todytp = new Date(this.date_end.replace(/-/g,'/')).getTime()/1000;
                let userChotp = new Date(this.date_begin.replace(/-/g,'/')).getTime()/1000;
                if(todytp == userChotp){
                    let nowAndNows = this.getTodayStopSellTimeFuncs(this.date_begin.replace(/-/g,'/'),this.hour_td);
                    if(nowAndNows < this.todayStopSellTimestamps){
                        Toast("该商品已过当天售卖时间");
                        return false;
                    }
                }

                let that = this;
                layer.open({
                    content: '您确定要将该商品加入购物车？',
                    btn: ['确定', '取消'],
                    yes: function(index){
                        let goods_id = that.$route.query.goods_id;
                        let year = parseInt(that.date_begin.split("-")[0]);
                        let month = parseInt(that.date_begin.split("-")[1]);
                        let day = parseInt(that.date_begin.split("-")[2]);
                        let toyear = parseInt(that.date_end.split("-")[0]);
                        let tomonth = parseInt(that.date_end.split("-")[1]);
                        let today = parseInt(that.date_end.split("-")[2]);



                        let ajaxData = {
                            goods_id:that.$route.query.goods_id,
                            goods_num:that.buyNum,
                            year:year,
                            month:month,
                            day:day,
                            toyear:toyear,
                            tomonth:tomonth,
                            today:today,
                        };

                        that.$http({
                            xhrFields: {
                                withCredentials: true
                            },
                            crossDomain: true,
                            method: "post",
                            url: that.weburl + that.hurl + "/Cart/ajaxAddCart",
                            dataType:"json",
                            data:ajaxData
                        })
                        .then( res => {
                            if(res.data.status == 1){
                                Toast(res.data.msg);
                            }else{
                                Toast(res.data.msg);
                            }
                        })
                        .catch( err => {
                            Toast("网络错测，稍后再试");
                            console.log(err);
                        })
                        layer.close(index);
                    }
                });
            },
            // 将关键词的字符串转换为数组
            getKeyWords:function (keyWordStr) {
                let keyWordArr = [];
                if(keyWordStr){
                    keyWordArr = keyWordStr.split(" ");
                }
                return keyWordArr;
            },

            // 点击“+”号所触发的方法
            addNum:function () {
                this.buyNum += 1;
            },

            // 点击“-”号所触发的方法
            delNum:function () {
                this.buyNum -= 1;
            },

            // 解码的方法
            htmlDecode:function (text) {
                var temp = document.createElement("div");
                temp.innerHTML = text;
                var output = temp.innerText || temp.textContent;
                temp = null;
                return output;
            },

            //显示日历
            openPicker:function () {
                this.$refs.dateTime.show();
            },

            select:function (val) {
                this.date = val;
            },

            //获取当前时间，格式YYYY-MM-DD
            getNowFormatDate:function () {
                var date = new Date();
                var seperator1 = "/";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },

            // 点击“立即预定”按钮所触发的方法
            bookBtnFunc:function (cat_id_2) {
                // 判断该商品当天是否已经超过售卖时间
                // let tody = this.getNowFormatDate();
                // let todytp = new Date(tody.replace(/-/g,'/')).getTime()/1000;
                // let userChotp = new Date(this.date.replace(/-/g,'/')).getTime()/1000;
                // if(todytp == userChotp){
                //     let nowAndNows = (new Date()).getTime()/1000;
                //     if(nowAndNows > this.todayStopSellTimestamps){
                //         Toast("该商品已过当天售卖时间");
                //         return false;
                //     }
                // }
                // 判断是否登录，如果没有登录的话，先让用户去登录
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + this.hurl + "/User/checkLogin",
                    dataType:"json",
                    data:{
                        cart:this.selectedNumIdArr
                    }
                })
                    .then( res => {
                        // console.log(res);
                        if(res.data.status == 1){
                            if(res.data.result){
                                if(!this.date){
                                    Toast("请选择购买日期");
                                    return false;
                                }
                                // 判断该商品当天是否已经超过售卖时间
                                // let tody = this.getNowFormatDate();
                                let todytp = new Date(this.date_end.replace(/-/g,'/')).getTime()/1000;
                                let userChotp = new Date(this.date_begin.replace(/-/g,'/')).getTime()/1000;
                                if(todytp == userChotp){
                                    let nowAndNows = this.getTodayStopSellTimeFuncs(this.date_begin.replace(/-/g,'/'),this.hour_td);
                                    console.log(nowAndNows);
                                    console.log(this.hour_td);
                                    console.log(this.todayStopSellTimestamps);

                                    if(nowAndNows < this.todayStopSellTimestamps){
                                        Toast("该商品已过当天售卖时间");
                                        return false;
                                    }
                                }
                                // 利用本地存储技术localStorage将用户选择的本件商品的数据保存到浏览器端，以供在订单页面使用数据
                                let goodsOrderInfo = {};
                                goodsOrderInfo.goods_id = this.goods_info.goods_id;
                                goodsOrderInfo.goods_name = this.goods_info.goods_name;
                                goodsOrderInfo.shop_price = this.goods_info.shop_price;
                                goodsOrderInfo.original_img = this.goods_info.original_img;
                                goodsOrderInfo.goods_num = this.buyNum;
                                localStorage.setItem("goodsOrderInfo",JSON.stringify(goodsOrderInfo));
                                localStorage.setItem("totalPrices",this.totalPrices);
                                localStorage.setItem("chooseDate",this.date_begin);
                                localStorage.setItem("chooseToDate",this.date_end);

                            // 跳转到订单页面
                            this.$router.push({ path: '/order', query: {to_order_way: 1,cat_id_2: cat_id_2}});
                        }else{
                            Toast("请先登陆");
                            // 等1秒跳到登录页面
                            setTimeout(() => {
                                this.$router.push({ path: '/login'});
                            }, 1500);
                        }
                    }else{
                        Toast("网络错误,请稍后再试")
                    }
                })
                .catch( err => {
                    Toast("网络错误,请稍后再试")
                    console.log(err);
                })

            }



        },
        watch:{
            buyNum: function (n,o) {
                let unitPrice = this.unitPrices;
                unitPrice = parseFloat(unitPrice);
                this.totalPrices = n * unitPrice;
                if(n < 1){
                    Toast("购买数量不能小于1");
                    this.buyNum = 1;
                }
                this.totalPrices = (n * unitPrice).toFixed(2);
            },
            unitPrices: function (n,o) {
                let unitPrice = n;
                unitPrice = parseFloat(unitPrice);
                this.totalPrices = this.buyNum * unitPrice;
                this.totalPrices = (this.buyNum * unitPrice).toFixed(2);
            }
        }
    }
</script>
<style scoped lang="less">
    @import '../../assets/less/common.less';
.carousel {
    width: 100%;
    height: 213px;
    img {
        .img;
    }
}
.ticket_detail {
   .box-sizing;
    padding:  10px;
    .border-bottom(5px ; #e1e1e1);
    /*border-bottom: 5px solid #e1e1e1;*/
    h1{
        font-size:@font ;
        line-height: 30px;
        margin-bottom: @font / 5;
    }
    ul{
      display: flex;
      flex-wrap:wrap;
        margin-bottom: @font / 2;
        li{
            padding:2px 5px;
            background: @subject_color;
            color:#fff;
            font-size:@font / 2;
            -webkit-border-radius: 4px;
            -moz-border-radius: 4px;
            border-radius: 4px;
            margin: 0 8px  4px  0;
            &:last-child{
                margin-right: 0;
            }

        }
    }
    p{
        line-height: 35px;
        font-size:.9rem;
        .discounts_price {
            color:@subject_color;
            font-size:@font + .4;
            position: relative;
            &:before{
                content:'￥';
                font-size:@font;
                top:-6px;
                left:-12px;
            }
        }
        s{
            color:#7a7b80;
            font-size:1rem;
            margin-left: 10px;
        }
        &.buy_num span ,&.buy_num input {
            float: right;
            display: inline-block;
            width: 25px;
            height: 25px;
            text-align: center;
            line-height: 25px;
            font-size:@font + .2;
            margin-top: 5px;
            border-radius: 4px;
        }
        &.buy_num span{
            color:#fff;
            background: @brick_red;
            // &:nth-child(2n-1){
            //     color:#FFF;
            //     background: @brick_red;
            // }
            // &:nth-child(2n){
            //     border: 1px solid @brick_red;
            //     margin:5px 5px 0 5px;
            //    .box-sizing;
            //  }

        }
        &.buy_num input {
             border: 1px solid @brick_red;
             margin:5px 5px 0 5px;
            .box-sizing;
        }
        .detail_calendar{
            width: 50%;
            height: 24px;
            line-height: 24px;
            float: right;
            margin: 6px 25% 0 0;
            @media(max-width: 360px) {
                margin: 6px 46% 0 0;
            }
            position: relative;
            &:after{
                content: '';
                width: 20px;
                height: 30px;
                background: url("@{sprite}")  no-repeat -216px -12px ;
                background-size: 238px  auto;
                top: 0;
                right: -18px;
            }
        }

    }
    .detail_btns {
        width: @width;
        height: 58px;
        &>div, &>span{
            float: left;
            height: @width;
        }
        &>div{
            width: 30%;
            @media (max-width: 320px){
                width: 29%;
            }
            b,span{
                display: block;
            }
            b{
                // font-size:@font - .6;
                font-size: 0.9rem;
            }
            span{
                position: relative;
                color:@subject_color;
                margin-left: 10px;
                margin-top: 10px;
                font-size:@font + .4;
                &:before{
                    top: 2px;
                    left: -12px;
                    content: '￥';
                    font-size:@font;
                }
            }

        }
        &>span{
            height: 45px;
            line-height: 45px;
            margin-left: 15px;
            text-align: center;
            color:#fff;
            border-radius: 10px;
            margin-top: 7px;
        }
        .buyCar {
            width: 37%;
            padding-left: 28px;
            position: relative;
            .box-sizing;
            background:@brick_red;
            &:before{
                content: '';
                background: url("@{sprite}")  no-repeat 0 0;
                width: 30px;
                height: 45px;
                top:0;
                left:3px;
                background-size: 238px auto;
            }
        }
        .bookBtn{
            background: @subject_color;
            width: 24%;
        }
    }

}
.detail_info{
    width: 96%;
    margin:  auto;
    padding: 10px  0;
    // height: 100px;
    /*background: yellow;*/
}
.swiper{
    height: 200px;
}
.swiper-item img{
    width: 100%;
    height: 100%;
}
.greyCeng{
    height: 100vh;
    width: 100vw;
    position: fixed;
    background-color: gray;
    opacity: 0.5;
    z-index: 101;
}

    @media (min-width: 768px) {
        .carousel {
            height: 322px;
        }
        .ticket_detail {
            h1{
                font-size:@font + .5;
                line-height: 35px;
                margin-bottom: @font ;
            }
            ul{
                display: flex;
                flex-wrap:wrap;
                margin-bottom: @font / 2;
                li{
                    padding: 5px ;
                    font-size: .8rem;
                    &:last-child{
                        margin-right: 0;
                    }

                }
            }
            p{
                line-height: 35px;
                font-size:1rem;
                .discounts_price {
                    color:@subject_color;
                    font-size:@font + .4;
                    position: relative;
                    &:before{
                        content:'￥';
                        font-size:@font;
                        top:-6px;
                        left:-12px;
                    }
                }
                s{
                    color:#7a7b80;
                    font-size:1rem;
                    margin-left: 10px;
                }
                &.buy_num span ,&.buy_num input {
                    float: right;
                    display: inline-block;
                    width: 25px;
                    height: 25px;
                    text-align: center;
                    line-height: 25px;
                    font-size:@font + .2;
                    margin-top: 5px;
                    border-radius: 4px;
                }
                &.buy_num span{
                    color:#fff;
                    background: @brick_red;
                    // &:nth-child(2n-1){
                    //     color:#FFF;
                    //     background: @brick_red;
                    // }
                    // &:nth-child(2n){
                    //     border: 1px solid @brick_red;
                    //     margin:5px 5px 0 5px;
                    //    .box-sizing;
                    //  }

                }
                &.buy_num input {
                    border: 1px solid @brick_red;
                    margin:5px 5px 0 5px;
                    .box-sizing;
                }
                .detail_calendar{
                    width: 14%;
                    margin: 7px 72% 0 0;
                }

            }
            .detail_btns {
                height: 58px;
                &>div, &>span{
                    float: left;
                    height: @width;
                }
                &>div{
                    width: 55%;
                    b{
                        font-size: 1rem;
                        margin-bottom: .2rem;
                    }
                    span{
                        font-size:@font * 2;
                        line-height: 32px;
                    }

                }
                &>span{
                    height: 45px;
                    line-height: 45px;
                    margin-left: 20px;

                }
                .buyCar {
                    width: 19%;
                }
                .bookBtn{
                    width: 18%;
                }
            }

        }
        .detail_info{
            width: 96%;
            margin:  auto;
            padding: 10px  0;
            // height: 100px;
            /*background: yellow;*/
        }
        .swiper{
            height: 200px;
        }
        .swiper-item img{
            width: 100%;
            height: 100%;
        }
        .greyCeng{
            height: 100vh;
            width: 100vw;
            position: fixed;
            background-color: gray;
            opacity: 0.5;
            z-index: 101;
        }
    }

</style>
<style scoped>
    .detail_info >>> img {
        max-width: 100%;
     }
    .detail_info {
        line-height: 24px;
    }
</style>
